// French for the client timeline: the stream, its filters, the event editor and the toasts.
import { registerFr } from '../i18n/index.js';

registerFr({
  // toasts
  'Reconstruction started — the agent is reading the library (run #{id}).': 'Reconstruction démarrée — l’agent lit la bibliothèque (exécution #{id}).',
  'Reconstruction finished — {events}, {facts} recorded. Every row is yours to edit or delete.': 'Reconstruction terminée — {events}, {facts} enregistrés. Chaque ligne peut être modifiée ou supprimée par vous.',
  '{n} event': '{n} événement',
  '{n} events': '{n} événements',
  '{n} fact': '{n} fait',
  '{n} facts': '{n} faits',
  'Reconstruction {status} — {events} event(s), {facts} fact(s) landed before it stopped.': 'Reconstruction {status} — {events} événement(s), {facts} fait(s) enregistrés avant l’arrêt.',
  'Reconstruction {status}.': 'Reconstruction {status}.',
  'error': 'échouée',
  'aborted': 'interrompue',
  'timeout': 'expirée',
  'The event needs a title.': 'L’événement a besoin d’un titre.',
  'When did it happen? occurred-at is the date per the source, never today by default.': 'Quand cela s’est-il passé ? La date est celle de la source, jamais aujourd’hui par défaut.',
  'Event updated': 'Événement mis à jour',
  '{ref} recorded': '{ref} enregistré',
  '{ref} deleted': '{ref} supprimé',
  // document rows
  'superseded': 'remplacé',
  'Supersession lineage — explicit links and dates, never filename version labels': 'Chaîne de remplacement — liens et dates explicites, jamais d’étiquettes de version dans le nom de fichier',
  // event rows
  'open · with {owner}': 'ouverte · avec {owner}',
  'open · owner unrecorded': 'ouverte · responsable non enregistré(e)',
  'discharged {date}': 'honorée {date}',
  'Record that the promise was kept — a date and the artefact that kept it': 'Consigner que la promesse a été tenue — une date et l’artefact qui l’a honorée',
  'Discharge': 'Honorer',
  'Edit event': 'Modifier l’événement',
  'Delete event': 'Supprimer l’événement',
  'No source document anchors this event — fine, but anchored is better': 'Aucun document source n’ancre cet événement — c’est correct, mais ancré est préférable',
  'unanchored': 'non ancré',
  'Recorded by the reconstruction agent — always yours to correct': 'Enregistré par l’agent de reconstruction — toujours modifiable par vous',
  'agent': 'agent',
  'kept by': 'honoré par',
  // layout
  'document': 'document',
  'documents': 'documents',
  'event': 'événement',
  'events': 'événements',
  'Add event': 'Ajouter un événement',
  'Agent pass over the whole library: events for evidenced happenings, facts with source + quote. Auto-applied, audited, always yours to correct.': 'Passe de l’agent sur toute la bibliothèque : événements pour les faits avérés, faits avec source + citation. Appliqué automatiquement, consigné, toujours modifiable par vous.',
  'Reconstructing…': 'Reconstruction en cours…',
  'Reconstruct timeline': 'Reconstruire la chronologie',
  'Timeline': 'Chronologie',
  'all engagements': 'tous les mandats',
  'From': 'Du',
  'To': 'Au',
  'All': 'Tous',
  'Documents in this folder': 'Documents dans ce dossier',
  '{kind} events': 'Événements : {kind}',
  'Nothing matches these filters': 'Rien ne correspond à ces filtres',
  'Nothing on the timeline yet': 'Rien sur la chronologie pour l’instant',
  'Widen the date range or clear a chip.': 'Élargissez la période ou retirez un filtre.',
  'Every library document is automatically an entry here. Upload documents, or add an event by hand.': 'Chaque document de la bibliothèque devient automatiquement une entrée ici. Téléversez des documents ou ajoutez un événement à la main.',
  // editor
  'Kind': 'Type',
  'Date': 'Date',
  'Time': 'Heure',
  'Title': 'Titre',
  "What happened — 'NDA signed', 'Kickoff agreed for July'": 'Ce qui s’est passé — «NDA signé», «Kick-off convenu pour juillet»',
  'Summary': 'Résumé',
  'Engagement': 'Mandat',
  '— none (client-wide) —': '— aucun (tout le client) —',
  'Participants — one per line,': 'Participants — une personne par ligne,',
  'Source documents — the evidence this event anchors to': 'Documents source — les preuves auxquelles cet événement est ancré',
  'Loading the library…': 'Chargement de la bibliothèque…',
  'The library is empty — the event will be recorded unanchored.': 'La bibliothèque est vide — l’événement sera enregistré sans ancrage.',
  'Cancel': 'Annuler',
  'Saving…': 'Enregistrement…',
  'Save event': 'Enregistrer l’événement',
  'Deleting…': 'Suppression…',
  'Delete': 'Supprimer',
  'Delete “{label}”? The documents it anchored to stay in the library — only the event goes. The audit log keeps the record.': 'Supprimer «{label}» ? Les documents qui y étaient ancrés restent dans la bibliothèque — seul l’événement disparaît. La piste d’audit conserve l’entrée.',
  // EVENT_KINDS (option labels, badges, chips)
  'meeting': 'réunion',
  'decision': 'décision',
  'signature': 'signature',
  'commitment': 'promesse',
  'milestone': 'jalon',
  'participant': 'participant',
  'note': 'note',
  // folder chips (document folders, plus the client-side 'unclassified')
  'correspondence': 'correspondance',
  'agreement': 'accord',
  'financial': 'finances',
  'specification': 'spécification',
  'presentation': 'présentation',
  'image': 'image',
  'deliverable': 'livrable',
  'reference': 'référence',
  'unclassified': 'non classifié',
}, 'ClientTimeline');
